module.exports = __webpack_public_path__ + "img/newUpload-1.7e7df66d.png";